export const equals = (t1?: string, t2?: string, ignoreCase = true) => {

    if (t1 === t2) return true;

    if (!t1 || !t2) return false;

    if (!ignoreCase) return false;

    return t1.toLowerCase() === t2.toLowerCase();
};


export const trimChar = (string: string, charsToRemove: string[] | string, start = true, end = true) => {
    if (!string) return string;
    while (start && charsToRemove.includes(string.charAt(0))) {
        string = string.substring(1);
    }

    while (end && charsToRemove.includes(string.charAt(string.length - 1))) {
        string = string.substring(0, string.length - 1);
    }

    return string;
};

export const getTruncatedText = (text: string, max?: number) => {
    if (typeof max !== 'number') return text;
    return text.length > max ? text.slice(0, max) + '…' : text;
};

export const getTruncatedTextByWord = (text: string, max?: number) => {
    if (typeof max !== 'number' || text.length <= max) return text;
    const truncated = text.slice(0, max);
    const lastSpace = truncated.lastIndexOf(' ');
    if (lastSpace > 0) {
        return truncated.slice(0, lastSpace) + '…';
    }
    return truncated + '…';
};

/**Capitalize first letter of a string */
export const uppercaseFirstLetter = (text: string) => text?.charAt(0).toUpperCase() + text?.slice(1);

/**Transform kebab cased uri into readable label: E.g: `test-route` becomes `Test route` */
export const transformUriIntoLabel = (uri: string) => uppercaseFirstLetter(uri).replaceAll('-', ' ');

/** Generate a slug based on a string. Lowercase and replaces spaces and special characters with hyphens */
export const generateSlug = (text: string) => text?.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-').replace(/-+/g, '-');
